// IMPORT PACKAGE REFERENCES
import React from "react";
import styles from "./Toolbar.module.scss"; // Import css modules stylesheet as styles
import { Button } from "@material-ui/core";
import { withTranslation } from "react-i18next";

// COMPONENT
class Toolbar extends React.Component {
  render() {
    return (
      <div className={styles.toolbar}>
          <Button color="primary" onClick={this.props.multiSelect}>{ this.props.multiSelectLabel }</Button>
          { this.props.showDelete && <Button color="primary" onClick={this.props.onDelete}>{this.props.t('common.delete')}</Button>}
      </div>
    );
  }
}

export default withTranslation()(Toolbar)
